var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: { title: "发票详情", visible: _vm.dialogVisible, size: "90%" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "pl20",
        },
        [
          _c(
            "el-descriptions",
            {
              staticClass: "desc-block",
              attrs: { title: "开票信息", column: 2, border: "" },
            },
            [
              _c("el-descriptions-item", { attrs: { label: "申请单号" } }, [
                _vm._v(_vm._s(_vm.dataDetail.invoiceCode || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "开票订单号" } }, [
                _vm._v(_vm._s(_vm.dataDetail.orderNo || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "发票抬头" } }, [
                _vm._v(_vm._s(_vm.dataDetail.invoiceTitle || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "开票金额" } }, [
                _vm._v(
                  "¥" +
                    _vm._s(Number(_vm.dataDetail.invoiceAmount || 0).toFixed(2))
                ),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "开票类型" } },
                [
                  _vm.dataDetail.invoiceType === 1
                    ? _c(
                        "el-tag",
                        { attrs: { type: "success", size: "mini" } },
                        [_vm._v("企业")]
                      )
                    : _c("el-tag", { attrs: { type: "info", size: "mini" } }, [
                        _vm._v("个人"),
                      ]),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "发票类型" } },
                [
                  _vm.dataDetail.category === 1
                    ? _c("el-tag", { attrs: { size: "mini" } }, [
                        _vm._v("增值税普通发票"),
                      ])
                    : _vm.dataDetail.category === 2
                    ? _c(
                        "el-tag",
                        { attrs: { type: "warning", size: "mini" } },
                        [_vm._v("增值税专用发票")]
                      )
                    : _vm.dataDetail.category === 3
                    ? _c(
                        "el-tag",
                        { attrs: { type: "primary", size: "mini" } },
                        [_vm._v("电子发票")]
                      )
                    : _c("span", [_vm._v("-")]),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "税号" } }, [
                _vm._v(_vm._s(_vm.dataDetail.taxNo || "-")),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "开票状态" } },
                [
                  _vm.dataDetail.status === 0
                    ? _c("el-tag", { attrs: { type: "info", size: "mini" } }, [
                        _vm._v("申请中"),
                      ])
                    : _vm.dataDetail.status === 1
                    ? _c(
                        "el-tag",
                        { attrs: { type: "success", size: "mini" } },
                        [_vm._v("已开票")]
                      )
                    : _vm.dataDetail.status === 2
                    ? _c(
                        "el-tag",
                        { attrs: { type: "danger", size: "mini" } },
                        [_vm._v("已拒绝")]
                      )
                    : _c("span", [_vm._v("-")]),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "申请人" } }, [
                _vm._v(_vm._s(_vm.dataDetail.userName || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "申请日期" } }, [
                _vm._v(_vm._s(_vm.formatDateTime(_vm.dataDetail.applyTime))),
              ]),
              _c("el-descriptions-item", { attrs: { label: "开票日期" } }, [
                _vm._v(_vm._s(_vm.formatDateTime(_vm.dataDetail.invoiceTime))),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "企业地址", span: 2 } },
                [_vm._v(_vm._s(_vm.dataDetail.companyAddress || "-"))]
              ),
              _c("el-descriptions-item", { attrs: { label: "企业电话" } }, [
                _vm._v(_vm._s(_vm.dataDetail.companyPhone || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "邮箱" } }, [
                _vm._v(_vm._s(_vm.dataDetail.email || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "开户银行" } }, [
                _vm._v(_vm._s(_vm.dataDetail.bankName || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "银行账户" } }, [
                _vm._v(_vm._s(_vm.dataDetail.bankAccount || "-")),
              ]),
            ],
            1
          ),
          _vm.dataDetail.status === 0
            ? _c(
                "div",
                {
                  staticClass: "go-btn",
                  on: {
                    click: function ($event) {
                      return _vm.handleUploadInvoice(_vm.dataDetail.id)
                    },
                  },
                },
                [_vm._v("去开票 ")]
              )
            : _vm._e(),
          _vm.dataDetail.order
            ? _c(
                "el-descriptions",
                {
                  staticClass: "desc-block",
                  attrs: { title: "订单信息", column: 2, border: "" },
                },
                [
                  _c("el-descriptions-item", { attrs: { label: "订单号" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.order.orderNo || "-")),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "订单状态" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.orderStatusTag(
                              _vm.dataDetail.order.status
                            ),
                            size: "mini",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.orderStatusText(_vm.dataDetail.order.status)
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("el-descriptions-item", { attrs: { label: "收货人" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.order.realName || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "收货电话" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.order.userPhone || "-")),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "收货地址", span: 2 } },
                    [_vm._v(_vm._s(_vm.dataDetail.order.userAddress || "-"))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "商品总数" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.order.totalNum || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "商品总价" } }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          Number(
                            _vm.dataDetail.order.proTotalPrice || 0
                          ).toFixed(2)
                        )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "邮费" } }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          Number(
                            _vm.dataDetail.order.totalPostage || 0
                          ).toFixed(2)
                        )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "订单总价" } }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          Number(_vm.dataDetail.order.totalPrice || 0).toFixed(
                            2
                          )
                        )
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "优惠券金额" } },
                    [
                      _vm._v(
                        "¥" +
                          _vm._s(
                            Number(
                              _vm.dataDetail.order.couponPrice || 0
                            ).toFixed(2)
                          )
                      ),
                    ]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "实际支付" } }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          Number(_vm.dataDetail.order.payPrice || 0).toFixed(2)
                        )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "支付方式" } }, [
                    _vm._v(
                      _vm._s(_vm.payTypeText(_vm.dataDetail.order.payType))
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "支付时间" } }, [
                    _vm._v(
                      _vm._s(_vm.formatDateTime(_vm.dataDetail.order.payTime))
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "支付渠道" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.payChannelText(_vm.dataDetail.order.payChannel)
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "退款状态" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.refundStatusText(_vm.dataDetail.order.refundStatus)
                      )
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "创建时间", span: 2 } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.formatDateTime(_vm.dataDetail.order.createTime)
                        )
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "用户备注", span: 2 } },
                    [_vm._v(_vm._s(_vm.dataDetail.order.userRemark || "-"))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "平台备注", span: 2 } },
                    [_vm._v(_vm._s(_vm.dataDetail.order.remark || "-"))]
                  ),
                ],
                1
              )
            : _vm.dataDetail.storeOrder
            ? _c(
                "el-descriptions",
                {
                  staticClass: "desc-block",
                  attrs: { title: "订单信息", column: 2, border: "" },
                },
                [
                  _c("el-descriptions-item", { attrs: { label: "订单号" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.storeOrder.orderNo || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "履约方式" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.dataDetail.storeOrder.deliveryType === 2
                          ? "快递发货"
                          : "到店核销"
                      )
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "商品", span: 2 } },
                    [
                      _vm._v(
                        _vm._s(_vm.dataDetail.storeOrder.productName || "-") +
                          "（" +
                          _vm._s(_vm.dataDetail.storeOrder.sku || "默认") +
                          " × " +
                          _vm._s(_vm.dataDetail.storeOrder.payNum) +
                          "）"
                      ),
                    ]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "联系人" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.storeOrder.realName || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "联系电话" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.storeOrder.userPhone || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "商品金额" } }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          Number(
                            _vm.dataDetail.storeOrder.totalPrice || 0
                          ).toFixed(2)
                        )
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "优惠券抵扣" } },
                    [
                      _vm._v(
                        "¥" +
                          _vm._s(
                            Number(
                              _vm.dataDetail.storeOrder.couponPrice || 0
                            ).toFixed(2)
                          )
                      ),
                    ]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "积分抵扣" } }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          Number(
                            _vm.dataDetail.storeOrder.integralPrice || 0
                          ).toFixed(2)
                        )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "实际支付" } }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          Number(
                            _vm.dataDetail.storeOrder.payPrice || 0
                          ).toFixed(2)
                        )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "支付时间" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatDateTime(_vm.dataDetail.storeOrder.payTime)
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "完成时间" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatDateTime(_vm.dataDetail.storeOrder.finishTime)
                      )
                    ),
                  ]),
                ],
                1
              )
            : _c("el-alert", {
                staticClass: "desc-block",
                attrs: { title: "暂无订单信息", type: "info", closable: false },
              }),
          _vm.dataDetail.product
            ? _c(
                "el-descriptions",
                {
                  staticClass: "desc-block",
                  attrs: { title: "商品信息", column: 2, border: "" },
                },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "商品名称", span: 2 } },
                    [_vm._v(_vm._s(_vm.dataDetail.product.name || "-"))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "商品ID" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.product.id || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "商品简介" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.product.intro || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "商品价格" } }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          Number(_vm.dataDetail.product.price || 0).toFixed(2)
                        )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "原价" } }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          Number(_vm.dataDetail.product.otPrice || 0).toFixed(2)
                        )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "单位" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.product.unitName || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "库存" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.product.stock || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "销量" } }, [
                    _vm._v(_vm._s(_vm.dataDetail.product.sales || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "运费来源" } }, [
                    _vm.dataDetail.product.freightSource === 1
                      ? _c("span", [_vm._v("京东物流实时运费")])
                      : _c("span", [_vm._v("本地运费模板")]),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "创建时间", span: 2 } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.formatDateTime(_vm.dataDetail.product.createTime)
                        )
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "商品图片", span: 2 } },
                    [
                      _vm.dataDetail.product.image
                        ? _c("el-image", {
                            staticStyle: {
                              width: "80px",
                              height: "80px",
                              "border-radius": "4px",
                            },
                            attrs: {
                              src: _vm.dataDetail.product.image,
                              fit: "cover",
                              "preview-src-list": [
                                _vm.dataDetail.product.image,
                              ],
                            },
                          })
                        : _c("span", [_vm._v("-")]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("el-alert", {
                staticClass: "desc-block",
                attrs: { title: "暂无商品信息", type: "info", closable: false },
              }),
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("关 闭")]
          ),
        ],
        1
      ),
      _c("InvoiceUploadForm", {
        ref: "uploadFormRef",
        on: { success: _vm.getDetail },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }